import React from 'react';
import './Overview.css';

function Overview() {
  const mockStats = {
    totalConversions: 47,
    totalAnalyses: 23,
    activeConnections: 3,
    totalUsers: 8
  };

  const recentActivity = [
    { id: 1, type: 'Conversion', name: 'Sales_Dashboard.wbx', status: 'Completed', date: '2025-12-22' },
    { id: 2, type: 'Analysis', name: 'Marketing Environment', status: 'Completed', date: '2025-12-21' },
    { id: 3, type: 'Conversion', name: 'Finance_Report.wbx', status: 'In Progress', date: '2025-12-21' },
    { id: 4, type: 'Analysis', name: 'Operations Environment', status: 'Completed', date: '2025-12-20' },
    { id: 5, type: 'Conversion', name: 'HR_Metrics.wbx', status: 'Completed', date: '2025-12-19' },
  ];

  return (
    <div className="overview-container">
      <div className="overview-header">
        <h1>Overview Dashboard</h1>
        <p>Monitor your migration progress and activity</p>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">⟲</div>
          <div className="stat-content">
            <h3>{mockStats.totalConversions}</h3>
            <p>Total Conversions</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">◈</div>
          <div className="stat-content">
            <h3>{mockStats.totalAnalyses}</h3>
            <p>Total Analyses</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⬡</div>
          <div className="stat-content">
            <h3>{mockStats.activeConnections}</h3>
            <p>Active Connections</p>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⚉</div>
          <div className="stat-content">
            <h3>{mockStats.totalUsers}</h3>
            <p>Total Users</p>
          </div>
        </div>
      </div>

      <div className="recent-activity">
        <h2>Recent Activity</h2>
        <div className="activity-table">
          <table>
            <thead>
              <tr>
                <th>Type</th>
                <th>Name</th>
                <th>Status</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {recentActivity.map((activity) => (
                <tr key={activity.id}>
                  <td>
                    <span className={`activity-type ${activity.type.toLowerCase()}`}>
                      {activity.type}
                    </span>
                  </td>
                  <td>{activity.name}</td>
                  <td>
                    <span className={`status-badge ${activity.status.toLowerCase().replace(' ', '-')}`}>
                      {activity.status}
                    </span>
                  </td>
                  <td>{activity.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Overview;
